export default __webpack_public_path__ + "static/media/[BTCLOD.COM] Fameye - PRAISE (Audio Slide)-320k (1).eafd1e7a.mp3";